module.exports = __webpack_public_path__ + "img/pr-4.f58dba45.png";